export function isLfgMlpUser(userId) {
    return userId.startsWith('lfg-mlp-');
}
